var map = {
	"./Answer": 2,
	"./Answer.jsx": 2,
	"./AnswerFeedback": 3,
	"./AnswerFeedback.jsx": 3,
	"./Quiz": 9,
	"./Quiz.jsx": 9,
	"./QuizItem": 4,
	"./QuizItem.jsx": 4,
	"./TextAnswer": 5,
	"./TextAnswer.jsx": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;